<app-layout-one-column>
  <div *ngIf="isError()"><h1>Error: {{errorMessage}}</h1><br/><br/></div>
  <div *ngIf="!isError()">
    <p>The page you are looking for requires additional permissions.</p>
    <hr>
  </div>
  <h2>Believe this is an error?</h2>
  <p>Contact AMA IT for assistance.</p>

<button class="button button-full"
        type="button"
        routerLink="/">
        OCM Home Page
</button>

</app-layout-one-column>
